const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_SRC = '//js-na2.hs-scripts.com/244423549.js';

export const loadHubSpot = () => {
  if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  const firstScript = document.getElementsByTagName('script')[0];

  script.type = 'text/javascript';
  script.id = HUBSPOT_SCRIPT_ID;
  script.async = true;
  script.defer = true;
  script.src = HUBSPOT_SCRIPT_SRC;

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};
